import { TextInput } from "@mantine/core";

// Helper function to validate incentive attribute value
const validateIncentiveAttribute = (status, attributeDefaultValue, attributeRegex) => {
  const valueStr = (attributeDefaultValue ?? '').toString().trim();
  const isRequiredInvalid = status && valueStr === '';
  let isPatternInvalid = false;
  
  if (status && !isRequiredInvalid && attributeRegex) {
    try {
      const regex = new RegExp(attributeRegex);
      isPatternInvalid = !regex.test(valueStr);
    } catch (e) {
      isPatternInvalid = false; // ignore malformed regex
    }
  }
  
  return {
    isRequiredInvalid,
    isPatternInvalid,
    isInvalid: isRequiredInvalid || isPatternInvalid,
  };
};

const IncentivesTable = ({
  incentives,
  toggleDetailVisibility,
  visibleDetails,
  handleInputChange,
  setIncentives,
}) => {
  const handleIncentivesChange = (incentiveId, attributeId, value) => {
    const updatedIncentives = incentives?.map((item) =>
      item.incentiveTemplateId === incentiveId
        ? {
            ...item,
            incentiveAttributes: item.incentiveAttributes.map((attr) =>
              attr.incentiveTemplateAttributeId === attributeId
                ? { ...attr, attributeDefaultValue: value }
                : attr
            ),
          }
        : item
    );
    setIncentives(updatedIncentives);
    handleInputChange(updatedIncentives);
  };

  const handleCheckboxChange = (event, incentiveId) => {
    const {
      target: { selected },
    } = { ...event };
    const updatedIncentivesStatus = incentives?.map((item) =>
      item.incentiveTemplateId === incentiveId
        ? { ...item, status: selected }
        : item
    );
    setIncentives(updatedIncentivesStatus);
    handleInputChange(updatedIncentivesStatus);
  };

  return (
    <div className="p-10px" style={{ pointerEvents: "auto" }}>
      <se-block height="400px">
        <se-table>
          <se-table-group-header>
            <se-table-item-header width="60px"></se-table-item-header>
            <se-table-item-header width="53px"></se-table-item-header>
            <se-table-item-header resizable="true" flex="1" max-width="200px">
              Incentive Type
            </se-table-item-header>
            <se-table-item-header
              flex="3"
              // max-width="600px"
              clickable="true"
              resizable="true"
            >
              Incentive Description
            </se-table-item-header>
            {/* <se-table-item-header flex="1" min-width="100px" resizable="true">
              Status
            </se-table-item-header> */}
          </se-table-group-header>
          {incentives.map((item) => (
            <se-table-group selectable="true" key={item.incentiveTemplateId}>
              <se-table-item width="53px">
                <se-icon
                  onClick={() =>
                    toggleDetailVisibility(item.incentiveTemplateId)
                  }
                  option="button"
                >
                  {(item?.status || visibleDetails[item.incentiveTemplateId])
                    ?"arrow2_up"
                    :"arrow2_down"}
                </se-icon>
              </se-table-item>
              <se-table-item width="60px">
                <se-checkbox
                  selected={item?.status}
                  onClick={(e) =>
                    handleCheckboxChange(e, item.incentiveTemplateId)
                  }
                ></se-checkbox>
              </se-table-item>
              <se-table-item max-width="200px">
                <span className="text-wrap">{item.incentiveName}</span>
              </se-table-item>
              <se-table-item>
                <span className="text-wrap" max-width="600px">
                  {item.incentiveDescription}
                </span>
              </se-table-item>
              {/* <se-table-item>
                <span className="text-wrap">
                  {item?.incentiveComputationFormula || "N/A"}
                </span>
              </se-table-item> */}
              {(item?.status || visibleDetails[item.incentiveTemplateId]) && (
                <div slot="detail">
                  {item?.incentiveAttributes?.map((inc) => {
                    const validation = validateIncentiveAttribute(
                      item?.status,
                      inc.attributeDefaultValue,
                      inc.attributeRegex
                    );
                    return (
                    <se-table-item key={inc.incentiveTemplateAttributeId}>
                      <div className="row align-items-center">
                        <div className="col-sm-3">
                          <div className="form-group row m-0 p-0">
                            <div className="col-sm-6 px-0 d-flex justify-content-end">
                              <label
                                htmlFor={`genset-input-${inc.incentiveTemplateAttributeId}`}
                                className="col-form-label text-wrap bold se-font-14px-bold"
                              >
                                {inc.attributeLabelName}
                              </label>
                              <span className="se-mandatory pl-2 pt-2 ">*</span>
                            </div>
                            <div className="col-sm-6">
                              <TextInput
                                id={`genset-input-${inc.incentiveTemplateAttributeId}`}
                                type="text"
                                className={!item?.status ? "opacity-50" : ""}
                                name={inc.attributeLabelName}
                                placeholder="Add Value"
                                value={inc.attributeDefaultValue ?? ''}
                                required={!!item?.status}
                                disabled={!item?.status}
                                aria-required={!!item?.status}
                                aria-invalid={!item?.status ? false : validation.isInvalid}
                                aria-describedby={`genset-error-${inc.incentiveTemplateAttributeId}`}
                                onChange={(e) =>
                                  handleIncentivesChange(
                                    item.incentiveTemplateId,
                                    inc.incentiveTemplateAttributeId,
                                    e.target.value
                                  )
                                }
                                error={
                                  item?.status && validation.isInvalid
                                    ? validation.isRequiredInvalid
                                      ? "Value is required"
                                      : inc?.attributeRegexMessage || "Value format is invalid"
                                    : null
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <span className="text-wrap">
                            {inc.attributeDescription}
                          </span>
                        </div>
                      </div>
                    </se-table-item>
                  )})}
                </div>
              )}
            </se-table-group>
          ))}
        </se-table>
      </se-block>
    </div>
  );
};

export default IncentivesTable;
